import { Component, ElementRef, OnInit } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';

import { BaseComponent } from '../../abstracts/base.abstract';
import { ModalParentIdEnum, ModalType } from '../../enums';
import { IModal } from '../../interfaces';
import { ModalService } from '../../services/internal/modal.service';

@Component({
    selector: 'app-wana-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
})
export class WanaModalComponent extends BaseComponent implements OnInit {
    public isModalOpened$: Observable<boolean>;
    public modalType: ModalType;
    public hasBody: boolean;
    public text: string;
    public title: string;
    public validateButtonLabel: string;
    public cancelButtonLabel: string;
    public buttons?: {
        label: string;
        klass: string;
        fct: () => void;
        placement?: 'middle' | 'end';
    }[];

    public modalParentIdEnum = ModalParentIdEnum;
    public parentIdType: ModalParentIdEnum;
    public modalTypeEnum = ModalType;

    private validateButtonFn: () => any;
    private cancelButtonFn: () => any;

    constructor(private elementRef: ElementRef, private modalService: ModalService) {
        super();
    }

    public ngOnInit(): void {
        this.isModalOpened$ = this.modalService.isOpened$;

        this.uns = fromEvent(this.elementRef.nativeElement, 'wheel').subscribe((event: any) => event.stopPropagation());

        this.uns = this.modalService.modalData$.subscribe((value: IModal) => {
            this.modalType = value.type;
            this.hasBody = !!value.body;
            this.parentIdType = value?.component?.parentIdRef;

            if (this.hasBody) {
                this.title = value.body.title;
                this.text = value.body.text;
                this.validateButtonLabel = value.body.validateButtonLabel;
                this.validateButtonFn = value.body.validateButtonFn;
                this.cancelButtonLabel = value.body.cancelButtonLabel;
                this.cancelButtonFn = value.body.cancelButtonFn;
                this.buttons = value.body.buttons;
            }
        });
    }

    public onValidateClicked(): void {
        this.closeModal();
        if (this.validateButtonFn) {
            this.validateButtonFn();
        }
    }

    public onCancelModal(): void {
        if (this.modalType === ModalType.NEXT_YEAR_TRANSITION) {
            return;
        }
        this.closeModal();
        if (this.cancelButtonFn) {
            this.cancelButtonFn();
        }
    }

    private closeModal(): void {
        this.modalService.closeModal();
    }
}
